<template>
  <div>
    <md-dialog
      :md-backdrop="true"
      :md-fullscreen="false"
      :md-active.sync="showDialog"
      class="dialog"
      style="width: 100%;"
    >
      <md-dialog-title>ตารางเวลา (Timetable)</md-dialog-title>

      <md-tabs md-dynamic-height>
        <md-tab md-label="ช่วงเช้า">
          <div>
            <table>
              <tr>
                <th></th>
                <th class="thfirst" colspan="3">CB2401</th>
              </tr>
              <tr>
                <td style="width: auto;">09.00 - 09.30</td>
                <td class="first" colspan="3">Register</td>
              </tr>
              <tr>
                <td style="width: auto;">09.30 - 09.50</td>
                <td>Introduction</td>
              </tr>
              <tr>
                <td style="width: autox;">09.50 - 11.00</td>
                <td class="first">2 Guest Speakers</td>
              </tr>
              <tr>
                <td style="width: auto;">11.00 - 12.00</td>
                <td>Lucky Draw</td>
              </tr>
              <tr>
                <td style="width: auto;">12.00 - 13.00</td>
                <td class="first">Launch</td>
              </tr>
              <tr>
                <td style="width: auto;">13.00 - 13.20</td>
                <td>Lucky Draw</td>
              </tr>
            </table>
          </div>
        </md-tab>
        <md-tab md-label="ช่วงก่อนเบรค">
          <div>
            <table>
              <tr>
                <th></th>
                <th class="thfirst">CB2401</th>
                <th class="thsecond">CB2402</th>
                <th class="ththird">CB2405</th>
              </tr>
              <tr>
                <td style="width: 200px;">13.20 - 13.40</td>
                <td class="first">Hatch: How KMUTT supports student entrepreneurship by วีรชา
                </td>
                <td class="second">How to make your web faster
                  <br>by ธนนันท์
                </td>
                <td class="third">3.75 ปี กับสิ่งที่มหาลัยไม่ ได้ (ตั้งใจจะ) สอน
                  <br>by Withee
                </td>
              </tr>
              <tr>
                <td style="width: 200px;">13.40 - 13.50</td>
                <td colspan="3">เปลี่ยนห้อง</td>
              </tr>
              <tr>
                <td style="width: 200px;">13.50 - 14.10</td>
                <td class="first">ผมไม่อยากทํางานประ จําเลยครับ
                  <br>by Smith
                </td>
                <td class="second">My Life can Edit ชีวิตเรา ตัดต่อได้
                  <br>by พีรกิตติ์
                </td>
                <td class="third">โลกของความขี้เกียจ
                  <br>by Chirateep
                </td>
              </tr>
              <tr>
                <td style="width: 200px;">14.10 - 14.20</td>
                <td colspan="3">เปลี่ยนห้อง</td>
              </tr>
              <tr>
                <td style="width: 200px;">14.20 - 14.40</td>
                <td class="first">ชีวิตในมหาลัยท่ีไม่ได้หยุดอยู่ที่ห้องเรียน
                  <br>by Chainarong&Nawapol
                </td>
                <td class="second">How an exchage program changed me (and my life)
                  <br>by Tirapat
                </td>
                <td class="third">เมื่อชีววิทยาไม่ได้อยู่ แค่ในหนังสือเรียน Bioinformatics 101
                  <br>by Jiramaetha
                </td>
              </tr>
              <tr>
                <td style="width: 200px;">14.40 - 15.00</td>
                <td colspan="3">BREAK</td>
              </tr>
            </table>
          </div>
        </md-tab>
        <md-tab md-label="ช่วงหลังเบรค">
          <div>
            <table>
              <tr>
                <td style="width: 200px;">15.00 - 15.20</td>
                <td class="first">What does a game designer do?
                  <br>by Warat
                </td>
                <td class="second">ทำงาน 2 ปีกับ การย้ายงาน 4 ที่
                  <br>by Sippakorn
                </td>
                <td class="third">วิถีชีวิตมนุษย์ล้อ
                  <br>by Sattaya
                </td>
              </tr>
              <tr>
                <td style="width: 200px;">15.20 - 15.30</td>
                <td colspan="3">เปลี่ยนห้อง</td>
              </tr>
              <tr>
                <td style="width: 200px;">15.30 - 15.50</td>
                <td class="first">2 ปีที่ไม่ได้ทํางานประจํา
                  <br>by Siwat
                </td>
                <td class="second">Dreams
                  <br>by Napassorn
                </td>
                <td class="third">Customer experience in action
                  <br>by Tamon
                </td>
              </tr>
              <tr>
                <td style="width: 200px;">15.50 - 16.00</td>
                <td colspan="3">เปลี่ยนห้อง</td>
              </tr>
              <tr>
                <td style="width: 200px;">16.00 - 16.20</td>
                <td class="first">ตะลุย Sillicon Valley กับ เด็กอายุ 17
                  <br>by Phoomparin
                </td>
                <td class="second">Blockchain::the real evolution and the next revolution
                  <br>by Rattapol
                </td>
                <td class="third">ศิลปะการสื่อสารและการ ทํางานร่วมกับผู้อื่น
                  <br>by Sutham
                </td>
              </tr>
            </table>
          </div>
        </md-tab>
      </md-tabs>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showDialog = false">Close</md-button>
      </md-dialog-actions>
    </md-dialog>

    <div
      class="time regisbtn d-flex align-items-center justify-content-center"
      @click="showDialog = true"
    >ตารางเวลา</div>
  </div>
</template>

<script>
export default {
  name: "DialogCustom",
  data: () => ({
    showDialog: false
  })
};
</script>

<style lang="css" scoped>
.time {
  font-size: 1.5rem;
  font-family: "Kanit", sans-serif;
  color: #dee3ea;
  width: 150px;
  height: 150px;
  background-color: transparent;
  border-radius: 10000000px;
  border-color: #43445c !important;
  border-width: 5px;
  border: solid;
  transition-duration: 0.3s;
}
.time:hover {
  transform: scale(1.15);
  border-color: #dee3ea !important;
  text-decoration: none;
}
.md-dialog {
  background-color: white;
  width: 100%;
  border-radius: 20px;
  max-height: 90% !important;
}

body {
  padding: 30px;
}
table {
  border-radius: 1em;
  width: 100%;
}

table,
th,
td {
  border: 0.75px solid rgb(181, 181, 181);
  border-collapse: collapse;
}

td {
  text-align: center;
}

td,
th {
  padding: 10px;
  text-align: center;
}

.first,
.second,
.third {
  color: white;
}

.first {
  background-color: rgb(220, 89, 147);
}

.second {
  background-color: rgb(130, 86, 156);
}

.third {
  background-color: rgb(62, 39, 98);
}

.thfirst {
  color: rgb(220, 89, 147);
}

.thsecond {
  color: rgb(130, 86, 156);
}

.ththird {
  color: rgb(62, 39, 98);
}
</style>



// WEBPACK FOOTER //
// src/components/dialogtimetb.vue